import { ChangeDetectionStrategy, Component, output, OutputEmitterRef } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { IconComponent } from '@libs/components/icons';

@Component({
  selector: 'ui-side-sheet-header',
  imports: [
    IconComponent,
    MatIconButton,
  ],
  templateUrl: './side-sheet-header.component.html',
  styleUrl: './side-sheet-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideSheetHeaderComponent {
  public closeSideSheet: OutputEmitterRef<void> = output();
}
